import {
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  GET_ALL_INVITATIONS, SELECT_INVITE_SUCCESS,
} from "../actions/userActions";

const INITIAL_STATE = {
  allUsers: null,
  invitations: null,
  selectedInvite: null,
};

export const userCreateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return { loading: true };
    case CREATE_USER_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload };
    case CREATE_USER_FAIL:
      return { loading: false, error: action.payload };
     case GET_ALL_INVITATIONS:
      return {...state, invitations: action.payload};
    case SELECT_INVITE_SUCCESS:
      return {...state, selectedInvite: action.payload};
    default:
      return state;
  }
};

export default userCreateReducer;